import { API_ENDPOINTS } from '@/constants/api'
import { apiClient } from '@/lib/api'

/**
 * Geolocate API service
 * Provides methods for regions and cities autocomplete
 */
export const geolocateApi = {
  /**
   * Get regions for autocomplete
   * @param {Object} params - { search, page, page_size }
   * @returns {Promise<Object>} Regions list with pagination
   */
  getRegionsAutocomplete: async (params = {}) => {
    const response = await apiClient.get(API_ENDPOINTS.GEOLOCATE.REGIONS_AUTOCOMPLETE, { params })
    return response
  },

  /**
   * Get cities for autocomplete
   * @param {Object} params - { search, page, page_size }
   * @returns {Promise<Object>} Cities list with pagination
   */
  getCitiesAutocomplete: async (params = {}) => {
    const response = await apiClient.get(API_ENDPOINTS.GEOLOCATE.CITIES_AUTOCOMPLETE, { params })
    return response
  },
}
